import {
    Component,
    ViewEncapsulation,
    Input,
    OnInit,
    Inject
} from '@angular/core';


@Component({
    selector: 'fullscreen',
    providers: [
        { provide: 'Document',  useValue: document }
    ],
    template: `
        <div (click)="clicked()" class="fullscreen-button">
            <div class="svgBg">
                <svg width="24" height="24">
                    <path class="st0" d="M15,3l2.3,2.3l-2.9,2.9l1.4,1.4l2.9-2.9L21,9V3H15z M3,9l2.3-2.3l2.9,2.9l1.4-1.4L6.7,5.3L9,3H3V9z M9,21
                    l-2.3-2.3l2.9-2.9l-1.4-1.4l-2.9,2.9L3,15v6H9z M21,15l-2.3,2.3l-2.9-2.9l-1.4,1.4l2.9,2.9L15,21h6V15z"/>
                </svg>
            </div>
        </div>
    `,
    // encapsulation: ViewEncapsulation.Native,
    styles: [
        require('css-to-string!./style.scss')
    ],
    directives: [],
})
export class Fullscreen implements OnInit {
    @Input() select: string;
    constructor(
        @Inject('Document') private document: Document
    ) {}
    ngOnInit() {
        if (!this.select) {
            console.error('The fullscreen directive requires the attribute \'select\' with an id specified.');
            return;
        }
    }
    private clicked() {
        // when clicked, toggle fullscreen mode on the element defined in the attrs.select
        let elem = this.document.getElementById(this.select);
        if (!this.document.fullscreenElement &&    // alternative standard method
              !this.document.mozFullScreenElement && !this.document.webkitFullscreenElement && !this.document.msFullscreenElement ) {  // current working methods
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (this.document.exitFullscreen) {
                this.document.exitFullscreen();
            } else if (this.document.msExitFullscreen) {
                this.document.msExitFullscreen();
            } else if (this.document.mozCancelFullScreen) {
                this.document.mozCancelFullScreen();
            } else if (this.document.webkitExitFullscreen) {
                this.document.webkitExitFullscreen();
            }
        }
    }
}




/** WEBPACK FOOTER **
 ** ./src/landing/directives/fullscreen/fullscreen.component.ts
 **/